
if (!customElements.get('card-product')) {
    customElements.define(
        'card-product',
        class CardProduct extends HTMLElement {
            constructor() {
                super();
                this.modalOpener = this.querySelector('[data-modal-opener]');
                this.wrapper = this.querySelector('.card-wrapper')
                this.isDesktop = window.innerWidth > 1024;
                this.quickOpenClass = 'quick-open'
            }

            connectedCallback() {
                this.modalOpener?.addEventListener('click', (e) => {
                    e.preventDefault()
                    this.wrapper.classList.contains(this.quickOpenClass) ? this.hideModal.bind(this)() : this.showModal.bind(this)();
                })
                subscribe(PUB_SUB_EVENTS.cartUpdate, this.hideModal.bind(this))
            }

            hideModal(preventFocus = false) {
                document.querySelectorAll('[data-quick-shop]').forEach((el) => el.remove());
                this.wrapper.classList.remove(this.quickOpenClass)

            }

            async showModal() {

                const response = await fetch(`/products/${this.dataset.productUrl}?view=quick-shop`);
                const responseText = await response.text();

                const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                this.productElement = responseHTML.querySelector('[data-quick-shop-content]');
                this.modalContent = this.querySelector('.card__inner');

                this.wrapper.classList.add(this.quickOpenClass)
                if (this.isDesktop) {
                    this.modalContent.insertAdjacentHTML('beforeend', this.productElement.innerHTML);
                } else {
                    document.querySelector('#MainContent').insertAdjacentHTML('afterend', this.productElement.innerHTML);
                }

                for (const closeModal of document.querySelectorAll('[data-close-modal]')) {
                    closeModal.addEventListener('click', this.hideModal.bind(this))
                }
            }
        }
    );
}




class CardProductRadios extends HTMLElement {
    constructor() {
        super();
        this.fieldset = this.querySelector('fieldset');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    }
    connectedCallback() {
        this.fieldset.addEventListener('change', this.handleVariantSelect.bind(this))
    }


    async handleVariantSelect() {
        const variantId = this.fieldset.querySelector('input:checked').value;

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];



        const formData = {
            items: [{
                quantity: 1,
                productId: this.dataset.productId,
                id: variantId,
                properties: {},
                sections: this.cart.getSectionsToRender().map((section) => section.section || section.id),
            }],
            sections_url: window.location.pathname,
            sections: this.cart.getSectionsToRender().map((section) => section.id)
        };

        const propertyInputs =
            this.querySelectorAll('input[name^="properties"]');

        propertyInputs?.forEach(input => {
            formData.items.forEach(item => {
                if (!input?.value) return
                const match = input.name.match(/\[(.*?)\]/);
                const extracted = match ? match[1] : null;
                item.properties[extracted] = input.value
            })
        });

        config.body = JSON.stringify(formData);
        config.headers = {
            'Content-Type': 'application/json',
            ...config.headers
        };


        const response = await fetch(`${routes.cart_add_url}`, config);

        const result = await response.json();

        if (response.status !== 200) {
            this.querySelector('[data-error]').innerHTML = result.message;
            return
        }

        this.cart.renderContents(result);

        publish(PUB_SUB_EVENTS.cartUpdate)

    }
}

customElements.define('card-product-radios', CardProductRadios);

